import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Moment from 'moment';
// material
import { styled } from '@mui/material/styles';
import {
  Card,
  Table,
  Stack,
  CircularProgress,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Icon,
  Typography,
  MenuItem,
  TableContainer,
  TablePagination,
  OutlinedInput,
  InputAdornment,
  useMediaQuery,
} from '@mui/material';
import { Box } from '@mui/system';
// import CopyToClipboard from 'react-copy-to-clipboard';
import { ContentCopy } from '@mui/icons-material';
import CopyToClipboard from 'react-copy-to-clipboard';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { toast } from 'react-toastify';

// components
import Scrollbar from './Scrollbar';
import Iconify from './Iconify';
import Popup from './popups/ProjectStatusChange';
import hasAccessOf from '../store/hasAccessOf';
import Filter from './filters/Projects';
import { StyledTableRow } from '../theme/styledComponents';

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

export default function Projects({ approved, customerId, workerId, managerId, engineerId }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [status, setStatus] = useState('');

  const matches = useMediaQuery('(max-width:600px)');
  const [projectsData, setProjectsData] = useState();
  const [name, setName] = useState('');
  const [pages, setPages] = useState(0);
  const [projectsCount, setProjectsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const [size, setSize] = useState(10);
  const [options, setOptions] = useState({
    size,
    page: 0,
    // approved: approved || '',
    // customerId,
    // workerId,
    // manager: managerId,
    // engineer: engineerId,
  });

  const projectCreateAccess = hasAccessOf('project.project.c');
  const projectReadAccess = hasAccessOf('project.project.r');
  const projectWriteAccess = hasAccessOf('project.project.w');
  const projectDeleteAccess = hasAccessOf('project.project.d');

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${item.status}` === event.target.value) {
      return;
    }
    setStatus(event.target.value);
    console.log(index);
    setSelectedIndex(index);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    if (refresh) {
      getProjects(options);
    }
    if (message) {
      toast(message);
    }
  };

  const handlePageChange = (event, newPage) => {
    const temp = { ...options, page: newPage };
    setPages(newPage);
    setOptions(temp);
    setIsLoading(true);
    getProjects(temp);
  };

  const getProjects = (options) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/project/all`, {
        params: {
          ...options,
          approved: approved || '',
          customerId,
          workerId,
          manager: managerId,
          engineer: engineerId,
        },
      })
      .then((res) => {
        console.log('tele caller', res);
        if (res.data.isError === false) {
          setIsLoading(false);
          setProjectsCount(res.data.data.maxRecords);
          setProjectsData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getProjectsWithoutLoading = (options) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/project/all`, {
        params: {
          ...options,
          approved: approved || '',
          customerId,
          workerId,
          manager: managerId,
          engineer: engineerId,
        },
      })
      .then((res) => {
        console.log('res', res);
        if (res.data.isError === false) {
          setProjectsCount(res.data.data.maxRecords);
          setProjectsData(res.data.data.records);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const onSearch = (e) => {
    e.preventDefault();
    setName(e.target.value);
    const temp = { ...options, page: 0, name: e.target.value };
    setOptions(temp);
    setPages(0);
    getProjectsWithoutLoading(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.engineer) {
      temp.engineer = filter.engineer;
    }
    if (filter.name) {
      temp.name = filter.name.trim();
    }
    if (filter.status) {
      temp.status = filter.status.trim();
    }
    if (filter.workOrderNumber) {
      temp.workOrderNumber = filter.workOrderNumber.trim();
    }
    if (filter.projectId) {
      temp.projectId = filter.projectId.trim();
    }
    if (filter.manager) {
      temp.manager = filter.manager.trim();
    }
    if (filter.customerId) {
      temp.customerId = filter.customerId.trim();
    }
    if (filter.customerName) {
      temp.customerName = filter.customerName.trim();
    }
    if (filter.startDate) {
      temp.startDate = filter.startDate.trim();
    }
    if (filter.endDate) {
      temp.endDate = filter.endDate.trim();
    }

    setOptions(temp);
    setPages(0);
    getProjects(temp);
  };
  useEffect(() => {
    getProjects(options);
  }, []);

  useEffect(() => {
    const temp = { ...options, size, page: 0 };
    setPages(0);
    setOptions(temp);
    getProjects(temp);
  }, [size]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Card>
          <Filter applyFilters={applyFilters} approved={approved} customer={customerId} filterValues={options} />

          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" spacing={2} padding={2}>
              <SearchStyle
                value={name}
                onChange={onSearch}
                placeholder="Search Project Name..."
                startAdornment={
                  <InputAdornment position="start">
                    <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                  </InputAdornment>
                }
              />
            </Stack>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Sl No</TableCell>
                    <TableCell>Project Name</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Work Order No.</TableCell>
                    <TableCell>Project ID</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {projectsData?.map((item, id) => ( 
                   <StyledTableRow key={id}>
                      <TableCell>{pages * size + (id + 1)}</TableCell>
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>{item?.customerData?.fullname}</TableCell>
                      <TableCell>{item.location}</TableCell>
                      <TableCell style={{ cursor: 'pointer', width: '100px' }}>
                        <Stack direction="column" spacing={0.5} width="100px">
                          <CopyToClipboard
                            text={item.workOrderNumber}
                            onCopy={() => toast.info('Work Order No. copied')}
                          >
                            <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="flex-start">
                              <ContentCopy color="primary" />
                              <Typography variant="p">{item.workOrderNumber}</Typography>
                            </Stack>
                          </CopyToClipboard>
                        </Stack>
                      </TableCell>
                      <TableCell style={{ cursor: 'pointer', width: '100px' }}>
                        <Stack direction="column" spacing={0.5} width="100px">
                          <CopyToClipboard text={item.projectId} onCopy={() => toast.info('Project ID copied')}>
                            <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="flex-start">
                              <ContentCopy color="primary" />
                              <Typography variant="p">{item.projectId}</Typography>
                            </Stack>
                          </CopyToClipboard>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        {projectWriteAccess && (
                          <FormControl sx={{ minWidth: 100 }}>
                            <Select size="small" value={item.status} onChange={(e) => handleStatusChange(e, item, id)}>
                              <MenuItem value="ASSESSMENT">Assessment</MenuItem>
                              <MenuItem value="APPROVED">Approved</MenuItem>
                              <MenuItem value="ONGOING">Ongoing</MenuItem>
                              <MenuItem value="PAUSED">Paused</MenuItem>
                              <MenuItem value="CANCELLED">Cancelled</MenuItem>
                              <MenuItem value="COMPLETED">Completed</MenuItem>
                            </Select>
                            {selectedIndex === id && <Popup item={item} handleClose={handleClose} status={status} />}
                          </FormControl>
                        )}
                        {!projectWriteAccess && (
                          <Typography variant="p" sx={{ fontWeight: 'bold' }}>
                            {item.status}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Link
                            to={
                              item.status === 'ASSESSMENT'
                                ? `/dashboard/project/assessment/view/${item._id}`
                                : `/dashboard/project/approved/view/${item._id}`
                            }
                          >
                            <Icon sx={{ color: 'gray' }}>
                              <RemoveRedEyeIcon />
                            </Icon>
                          </Link>
                        </Box>
                      </TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            onRowsPerPageChange={(e) => {
              setSize(e.target.value);
            }}
            component={'div'}
            count={projectsCount}
            showFirstButton
            showLastButton
            onPageChange={handlePageChange}
            rowsPerPage={size}
            page={pages}
          />
        </Card>
      )}
    </>
  );
}
